<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form
        class="form--custom"
        novalidate
        @submit.prevent="handleSubmit"
      >
        <v-card-text class="px-4 pt-0 pb-3">
          <p v-html="$t(`${namespace}.text`).replace('[COMPANY]', company.companyName)" />
          <v-textarea
            v-model="reason"
            :placeholder="$t(`${namespace}.textarea.fieldReasonPlaceholder`)"
            :error-messages="errors.collect($t(`${namespace}.textarea.fieldReasonName`))"
            v-validate="{ required: true, max: 200 }"
            :data-vv-name="$t(`${namespace}.textarea.fieldReasonName`)"
            required
            flat
            outline
            solo
            counter="200"
            color="accent"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer/>

          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close(null)"
          >
            {{ $t('Common.cancel') }}
          </a>

          <v-btn
            type="submit"
            :loading="isLoading"
            :disabled="isLoading"
            color="accent"
            depressed
            round
          >
            {{ $t(`${namespace}.confirm`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChangeCompanyStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage.anonymousCompanies.stopAnonymizationDialog',
      isLoading: false,
      reason: null
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleSubmit () {
      this.isLoading = true

      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          await this.$apiService.companyDataPurge.delete(this.company.companyId, {
            reason: this.reason
          })

          await this.$apiService.editCompanyStatus(this.company.companyId, 'offboarding')

          this.close(true)
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.success`)
          })
        }
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.error`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
